@import '../../../../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../settings-page.module.less';

.menu-toggle {
  height: 32px;
  width: 32px;

  border-radius: 6px;

  color: @settings-page--inventory-warehouse-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--inventory-warehouse-menu--hover--background-color;
    color: @settings-page--inventory-warehouse-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--inventory-warehouse-menu--active--background-color;
    color: @settings-page--inventory-warehouse-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--inventory-warehouse-open-menu--background-color;
  color: @settings-page--inventory-warehouse-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}

.table-container {
  width: 100%;
  border: @settings-page--table--border;
  border-radius: 4px;
}

.actions-column {
  min-width: 80px;
  max-width: 80px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.active-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-row {
  padding: @space-20;
  text-align: center;
}

.modal-body {
  height: auto;
  padding: @space-16;
  display: flex;
  gap: @space-16;
  flex-wrap: wrap;

  > div {
    min-width: 150px;
    flex: 1 1 20%;
    display: flex;
    flex-direction: column;
    gap: @space-8;

    > label {
      font-weight: 500;
      padding-left: @space-4;
    }
  }
}

.check {
  color: @settings-page--inventory-warehouse-check--icon-color;
  height: 12px;
  width: 12px;
}
